import { _on } from '../../utils';

import './title-generator.css';

// TODO: refactor code + replace old tabs with new approach

function showTitles(titles, qty) {
  titles.slice(0, qty).forEach(card => card.classList.add('visible'));
}

if (document.getElementById('id_topic')) {
  const suggestionTool = document.getElementById('id_topic');

  _on('input', 'title-generator__input', () => {
    if (suggestionTool.value === '') {
      return document
        .querySelector('.title-generator__field .hint')
        .classList.add('title-hint--active');
    }
    document.querySelector('.title-generator__field .hint').classList.remove('title-hint--active');
  });

  _on('click', 'title-generator__input', () => {
    document.querySelector('.title-generator__field .hint').classList.toggle('title-hint--active');
  });

  _on('click', 'js--hint-item', ({ target }) => {
    suggestionTool.value = target.dataset.topic;
    document.querySelector('.title-generator__field .hint').classList.remove('title-hint--active');
    suggestionTool.focus();
    document.getElementById('title-generator__form').submit();
  });

  _on('keydown', 'Escape', () => {
    document.querySelector('.title-generator__field .hint').classList.remove('title-hint--active');
  });

  _on('click', 'js--use-topic', ({ target }) => {
    const title = target.dataset.topic;
    window.bbSetOrder({ threshold: 180, title });
  });

  _on('click', 'tab-button', ({ target }) => {
    let activeTopicTab = 'tab-button--active';
    let activeTopicContent = 'tab-content--active';

    if (target.classList.contains(activeTopicTab)) {
      return;
    }

    document.querySelector(`.${activeTopicTab}`).classList.remove(activeTopicTab);
    target.classList.add(activeTopicTab);

    document.querySelector(`.${activeTopicContent}`).classList.remove(activeTopicContent);
    document
      .querySelector(`#${target.id.replace('tab-button', 'tab-content')}`)
      .classList.add(activeTopicContent);
  });

  let titlesToShow = {
    rare: 4,
    popular: 4,
    rand: 4,
  };

  if (document.querySelector('.topic-tab')) {
    new Promise(function (resolve) {
      resolve({
        rand: [...document.querySelectorAll('#tab-content--random .topic-card__wrapper')],
        popular: [...document.querySelectorAll('#tab-content--popular .topic-card__wrapper')],
        rare: [...document.querySelectorAll('#tab-content--rare .topic-card__wrapper')],
      });
    }).then(cards => {
      Object.entries(cards).forEach(([key, value]) => showTitles(value, titlesToShow[key]));

      _on('click', 'load-more--rare', () => {
        titlesToShow.rare = titlesToShow.rare + 6;
        showTitles(cards.rare, titlesToShow.rare);

        if (cards.rare.length <= titlesToShow.rare) {
          document.querySelector('.load-more--rare').style.display = 'none';
        }
      });

      _on('click', 'load-more--popular', () => {
        titlesToShow.popular = titlesToShow.popular + 6;
        showTitles(cards.popular, titlesToShow.popular);

        if (cards.popular.length <= titlesToShow.popular) {
          document.querySelector('.load-more--popular').style.display = 'none';
        }
      });

      _on('click', 'load-more--random', () => {
        titlesToShow.rand = titlesToShow.rand + 6;
        showTitles(cards.rand, titlesToShow.rand);

        if (cards.rand.length <= titlesToShow.rand) {
          document.querySelector('.load-more--random').style.display = 'none';
        }
      });
    });
  }
}
